import { ApiService } from "./api.service";
export default class PayablesAgingPeriodService extends ApiService {
  namespace = "Notepad";
  template = "AgingChartTemplate";
  DOMAIN = 24;
  icon = "";
  name = "Notepad";
  constructor() {
    super("payables-aging-period");
  }
}
